module.exports = "/_next/static/images/emily-clark@2x-54ae98c6abfcf7e2c7074afec3a974c9.png";